module.exports = __webpack_public_path__ + "static/media/help.0108391d.svg";